import CommonModal from "@/components/common/CommonModal";
import { Button } from "@/components/ui/button";
import { DollarSign, Loader2 } from "lucide-react";

interface CreateSalaryConfirmModalProps {
  show: boolean;
  readyUsersCount: number;
  attendanceStartDate: string;
  attendanceEndDate: string;
  isCreatingSalary: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const CreateSalaryConfirmModal = ({
  show,
  readyUsersCount,
  attendanceStartDate,
  attendanceEndDate,
  isCreatingSalary,
  onClose,
  onConfirm,
}: CreateSalaryConfirmModalProps) => (
  <CommonModal
    show={show}
    onClose={onClose}
    title=""
    className="max-w-md rounded-2xl p-0 overflow-hidden"
  >
    <div className="p-6 space-y-5">
      <div className="flex flex-col items-center text-center">
        <div className="h-12 w-12 rounded-full bg-emerald-50 text-emerald-600 flex items-center justify-center mb-3 border border-emerald-100">
          <DollarSign size={24} className="text-emerald-600" />
        </div>

        <h3 className="text-lg font-bold text-slate-900 font-heading">
          Confirm Salary Generation
        </h3>
        <p className="text-xs text-slate-500 mt-1 leading-relaxed">
          Are you sure you want to generate monthly salary for all verified ready users in this site?
        </p>
      </div>

      <div className="bg-slate-50 p-3.5 rounded-xl border border-slate-200/80 space-y-2 text-xs">
        <div className="flex justify-between items-center gap-4">
          <span className="text-slate-500 font-medium">Ready Employees:</span>
          <span className="font-bold text-emerald-700 bg-emerald-100/60 px-2 py-0.5 rounded">
            {readyUsersCount} Employees
          </span>
        </div>
        <div className="flex justify-between items-center gap-4">
          <span className="text-slate-500 font-medium">Salary Period:</span>
          <span className="font-semibold text-slate-800 text-right">
            {attendanceStartDate} to {attendanceEndDate}
          </span>
        </div>
      </div>

      <div className="flex items-center gap-3 w-full pt-1">
        <Button
          type="button"
          variant="outline"
          onClick={onClose}
          disabled={isCreatingSalary}
          className="flex-1 rounded-xl h-10 font-semibold text-xs cursor-pointer"
        >
          Cancel
        </Button>
        <Button
          type="button"
          onClick={onConfirm}
          disabled={isCreatingSalary}
          className="flex-1 rounded-xl h-10 font-semibold text-xs bg-emerald-600 hover:bg-emerald-700 text-white flex items-center justify-center gap-2 cursor-pointer"
        >
          {isCreatingSalary ? (
            <>
              <Loader2 className="w-4 h-4 animate-spin text-white" />
              Creating...
            </>
          ) : (
            "Confirm & Create"
          )}
        </Button>
      </div>
    </div>
  </CommonModal>
);

export default CreateSalaryConfirmModal;
